import {
  DOCFIS_SET_DOCUMENTOS_FISCAIS_SUCCESS,
  DOCFIS_SET_EXTRACT_SUCCESS,
  DOCFIS_SET_NOTA_FISCAL_SUCCESS,
} from '../actions/types';

const INITIAL_STATE = {
  documentosFiscais: [],
  documentosSelecionados: [],
  detalhesDocumentoFiscal: {},
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case DOCFIS_SET_DOCUMENTOS_FISCAIS_SUCCESS:
      return { ...state, documentosFiscais: payload };
    case DOCFIS_SET_NOTA_FISCAL_SUCCESS:
      return { ...state, detalhesDocumentoFiscal: payload };
    case DOCFIS_SET_EXTRACT_SUCCESS:
      return { ...state, documentosSelecionados: payload };
    default:
      return state;
  }
};
